export default __webpack_public_path__ + "static/media/hero.bb81b6bf.png";